import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
export const PrivacySection = () => {
  const privacyPoints = ['No raw messages stored – analyzed on the fly, then discarded.', 'De-identified & aggregated – leaders see trends, never individual chats.', 'Bank-grade encryption – every byte shielded in transit and at rest.'];
  return <section id="security" className="py-20 bg-[#1C1C1E] text-white relative overflow-hidden" data-id="element-157">
      <div className="absolute inset-0 opacity-5" data-id="element-158">
        <LockIcon size={400} className="absolute -right-20 -bottom-20 text-white" data-id="element-159" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-160">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-162">
            Privacy & Security
          </h2>
          <p className="text-xl text-gray-300" data-id="element-163">
            Your team's words stay theirs. We turn anonymized patterns—never
            personal content—into the insights you need to lead with confidence.
          </p>
        </div>
        <div className="max-w-2xl mx-auto" data-id="element-164">
          {privacyPoints.map((point, index) => <div key={index} className="flex items-start mb-6" data-id="element-165">
              <div className="mr-4 mt-1 bg-[#8679DF] rounded-full p-1" data-id="element-166">
                <CheckIcon size={16} className="text-white" data-id="element-167" />
              </div>
              <p className="text-gray-300" data-id="element-168">{point}</p>
            </div>)}
        </div>
      </div>
    </section>;
};